import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthenticationService} from '../auth/services/authentication.service';
import {UserRoleEnum} from '../../models/enum/user-role.enum';

@Component({
  selector: 'app-blank-configuration',
  template: ``
})
export class BlankConfigurationComponent implements OnInit {
  constructor(private router: Router,
              private authenticationService: AuthenticationService) {
  }

  ngOnInit(): void {
    if (this.authenticationService.currentUserRolesIds.length > 0) {
      if (this.authenticationService.currentUserRolesIds.includes(UserRoleEnum.AdministratorOfPractice)) {
        this.router.navigateByUrl('/configuration/practice-enterprise');
      } else {
        this.navigateToSafe();
      }
    } else {
      this.navigateToSafe();
    }
  }

  navigateToSafe() {
    this.router.navigateByUrl('/configuration/practice-doctors');
  }
}
